module.exports = __webpack_public_path__ + "img/graphic.ab9d6a72.svg";